export default __webpack_public_path__ + "static/media/metamask.c67b2502.svg";